import type { ReactNode } from 'react';

/**
 * Horizontal-scrollbarer Container fuer Tabellen auf schmalen Viewports.
 *
 * Behebt zugleich den `overflow-hidden`-Clip-Bug der bisherigen Wrapper: breite
 * Tabellen werden rechts nicht mehr abgeschnitten, sondern scrollen.
 *
 * - `className` stylt den aeusseren (scrollenden) Container — Default ist die
 *   Standard-Oberflaeche (Border + Radius + bg). Fuer Tabellen, die schon in
 *   einer Card stecken, `className=""` setzen.
 * - `minWidthClass` erzwingt den Scroll: ab dieser Breite scrollt die Tabelle
 *   horizontal statt zu komprimieren. Fuer schmale Tabellen `min-w-0` setzen —
 *   dann scrollt nur, was der Inhalt wirklich erzwingt (kein Zwangs-Scroll).
 */
export function TableScroll({
  children,
  className = 'rounded-md border border-border-subtle bg-bg-surface',
  minWidthClass = 'min-w-[640px]',
}: {
  children: ReactNode;
  className?: string;
  minWidthClass?: string;
}): JSX.Element {
  return (
    <div className={`overflow-x-auto ${className}`.trim()}>
      <div className={minWidthClass}>{children}</div>
    </div>
  );
}
